/* eslint-disable no-console, max-len */
import axios from 'axios';

const baseUrl = typeof window !== 'undefined' ? window?.__EXPERIENCE_PROPS__?.expConfiguration?.['flooring-base-url'] : '';
const enablePilotStore = typeof window !== 'undefined' ? window?.__EXPERIENCE_PROPS__?.expConfiguration?.['enable-pilot-store'] : '';

const getStoresApiBaseUrl = (path, params) => {
  return `${baseUrl}/${path}?${params}`;
};

export const storeById = (storeId) => {
  const path = 'api/hdms/getStore';
  const url = getStoresApiBaseUrl(path, `storeId=${encodeURIComponent(storeId)}`);
  return axios.get(url)
    .then(({ data }) => data)
    .catch((e) => {
      console.log(`Unable to retrieve store info for store ${storeId}`);
      return {};
    });
};

export const storesByZip = (zipcode) => {
  const path = 'api/hdms/getStores';
  const url = getStoresApiBaseUrl(path, `zipcode=${encodeURIComponent(zipcode)}&isPilot=true`);
  return axios.get(url).then(({ data }) => data);
};

export const getPilotStoreStatus = async (storeId) => {
  const baseApiUrl = `${baseUrl}/api/hdms`;
  const defaultResponse = { pilot: true, storeId: `${storeId}` };
  if (!enablePilotStore) { return defaultResponse; }
  try {
    const url = await axios.get(
      `${baseApiUrl}/storePilotStatus?storeId=${storeId}`
    );
    const data = await url.data;
    return data;
  } catch (err) {
    console.log(`Store pilot status failed for Store:#${storeId}`);
    console.log(err);

    return {
      pilot: false,
      storeId: `${storeId}`
    };
  }
};
